import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchTargets = async (
	impersonatorUserId: string
): Promise<AdminImpersonationTarget[]> => {
	const response = await cmsClient.get<AdminImpersonationTarget[]>(
		`/impersonation-assignments/user/${impersonatorUserId}/`
	);
	return response.data;
};

const useImpersonationTargets = (impersonatorUserId: string) => {
	return useQuery(
		["impersonation-targets", impersonatorUserId],
		() => fetchTargets(impersonatorUserId),
		{ enabled: !!impersonatorUserId }
	);
};

export default useImpersonationTargets;
